
import GenreMaker from '../anychart/genreMaker'; 

var BubbleChart = class BubbleChart extends GenreMaker {

    setData(state){
        console.log("entry bubble");
        super.setData(state);
        var subGenre = this.getSubGenre();
        
        this.chart.xAxis();
        this.chart.yAxis();

        for (var series in this.data) {
            this.chart.bubble(this.data[series]);
        }
    }

    createChart(){
        var chart = anychart.cartesian();
        return chart;
    }; 
};


    
GenreMaker.bubble = BubbleChart;

export var BubbleChart;



// WEBPACK FOOTER //
// ./src/anychart/bubbleChart.js